import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { addShareHolderDetails } from "../../../../Utility/Api";
import { WarehouseContext } from "../../../../Utility/UserContext";

const AddShareHolderDetailsForm = ({ data, closeModal, refreshList, shId }) => {
    const { showLoader, hideLoader } = useContext(WarehouseContext);
    const [form, setForm] = useState({
        name: data?.name || "",
        phone: data?.phone || "",
        equity: data?.equity || "",
        capital: data?.capital || "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader();
        try {
            const payload = {
                sh_id: shId,
                name: form.name,
                phone: form.phone,
                equity: form.equity,
                capital: form.capital,
            };

            if (data) {
                // await updateShareHolderDetails(data.id, payload);
                toast.success("Shareholder details updated successfully");
            } else {
                await addShareHolderDetails(payload);
                toast.success("Shareholder details added successfully");
            }

            closeModal();
            refreshList();
        } catch (error) {
            console.error("Error submitting shareholder details:", error);
            toast.error("Something went wrong");
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {data ? "Edit Shareholder Details" : "Add Shareholder Details"}
                        </h5>
                        <button type="button" className="btn-close" onClick={closeModal}></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="mb-2">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="mb-2">
                                <label className="form-label">Phone</label>
                                <input
                                    type="text"
                                    name="phone"
                                    value={form.phone}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="mb-2">
                                <label className="form-label">Equity (%)</label>
                                <input
                                    type="number"
                                    name="equity"
                                    value={form.equity}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="mb-2">
                                <label className="form-label">Capital (INR)</label>
                                <input
                                    type="number"
                                    name="capital"
                                    value={form.capital}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={closeModal}>
                                Close
                            </button>
                            <button type="submit" className="btn btn-primary">
                                {data ? "Update" : "Save"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddShareHolderDetailsForm;